/*********************** Custom JS for Boost AI Search & Discovery  ************************/

if(window.boostSDAppConfig){
  window.boostSDAppConfig = {
    ...window.boostSDAppConfig,
      themeInfo: {
      ...window.boostSDAppConfig.themeInfo,
      taeFeatures: {
        ...window.boostSDAppConfig.themeInfo.taeFeatures,
          instantSearch: "installed"
      }
    }
  }
} 

const customize = {
   updateProductItemISW: (componentRegistry) => {
      componentRegistry.useComponentPlugin('SearchProductItem', {
         name: 'Customize product item ISW',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization --------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector(`.boost-sd__suggestion-queries-item--product[data-id="${productId}"]`);
                  if (productItem) {
                     /* Use pure JS here */
                    if (productData.price_max != productData.price_min) {
                      const productPrice = productItem.querySelector(".boost-sd__suggestion-queries-item-amount");
                      const fromText = '<span class="boost-sd-custom-from-text">from</span>';
                      if (!productItem.querySelector(".boost-sd-custom-from-text") && productPrice) {
                        productPrice.insertAdjacentHTML('afterbegin', fromText);
                      }
                    }
                  }
                  // End -------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemISW]);